<template>
  <el-dialog
    :title="title"
    :visible="true"
    width="500px"
    :close-on-click-modal="false"
    :before-close="handleClose"
  >
    <el-form
      ref="representativePaymentForm"
      v-loading="loading"
      :model="representativePayment"
      :rules="rules"
      label-position="top"
      autocomplete="off"
      style="margin-bottom: 30px;"
      @submit.native.prevent="store"
    >
      <el-alert
        v-if="debit !== null"
        title="Tartozás"
        type="info"
        show-icon
        style="margin-bottom: 20px;"
        :closable="false"
      >
        Ennek a képviselőnek összesen <strong>{{ debit | currency }}</strong> tartozása van.
      </el-alert>
      <el-form-item
        prop="representative_user_id"
        label="Képviselő"
      >
        <el-select
          v-model="representativePayment.representative_user_id"
          v-loading="userLoading"
          :disabled="type === 'update'"
          style="width: 100%;"
          filterable
          @change="onUserChange"
        >
          <el-option
            v-for="user in users"
            :key="user.id"
            :label="`${user.last_name} ${user.first_name} (@${user.username})`"
            :value="user.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        label="Befizetés időpontja"
        prop="payment_date"
      >
        <el-date-picker
          v-model="representativePayment.payment_date"
          type="date"
          style="width: 100%;"
          :clearable="false"
          format="yyyy. MM. dd."
          value-format="yyyy-MM-dd"
          :picker-options="{ firstDayOfWeek: 1 }"
        />
      </el-form-item>
      <el-form-item
        label="Befizetett összeg"
        prop="amount"
      >
        <el-input-localized-numeric
          v-model="representativePayment.amount"
        >
          <template slot="append">Ft</template>
        </el-input-localized-numeric>
      </el-form-item>
      <el-form-item
        label="Megjegyzés"
        prop="comment"
      >
        <el-input
          v-model="representativePayment.comment"
          type="textarea"
        />
      </el-form-item>
    </el-form>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <div>
        <el-button @click="handleClose">
          Mégse
        </el-button>
        <el-button
          type="primary"
          :loading="buttonLoading"
          @click="store"
        >
          {{ buttonText }}
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: ['type', 'representativePaymentId'],
  data() {
    return {
      loading: false,
      buttonLoading: false,
      taskCount: 1,
      debit: null,
      userLoading: false,
      shops: [],
      shopLoading: false,
      representativePayment: {
        payment_date: new Date(),
      },
      rules: {
        representative_user_id: [
          {
            required: true,
            message: 'Mező kitöltése kötelező',
            trigger: 'change'
          }
        ],
        payment_date: [
          {
            required: true,
            message: 'Mező kitöltése kötelező',
            trigger: 'blur'
          }
        ],
        amount: [
          {
            required: true,
            message: 'Mező kitöltése kötelező',
            trigger: 'change'
          }
        ],
      },
    };
  },
  computed: {
    cars() {
      return this.$store.getters['car/cars'];
    },
    users() {
      return this.$store.getters['user/users'];
    },
    title() {
      if (this.type === 'add') {
        return 'Új befizetés';
      } else if (this.type === 'update') {
        return 'Befizetés módosítása';
      } else {
        return '';
      }
    },
    buttonText() {
      if (this.type === 'add') {
        return 'Hozzáadása';
      } else if (this.type === 'update') {
        return 'Módosítás';
      } else {
        return '';
      }
    },
  },
  async mounted() {
    this.loading = true;
    const requiredFetches = [];
    if (!this.users.length) {
      requiredFetches.push(this.$store.dispatch('user/fetchAll'));
    }
    await Promise.all(requiredFetches);
    if (this.representativePaymentId) {
      this.representativePayment = await this.$store.dispatch('representativePayment/fetch', this.representativePaymentId);
    }
    this.loading = false;
  },
  methods: {
    async onUserChange(id) {
      if (this.type === 'add') {
        this.userLoading = true;
        try {
          this.debit = await axios.get('api/representative-payments/debit/' + id);
          if (this.debit > 0) {
            this.$set(this.representativePayment, 'amount', parseFloat(this.debit));
          }
        } catch (e) {

        }
        this.userLoading = false;
      }
    },
    handleClose() {
      this.$confirm('Biztosan elveted a módosításokat?', {
        confirmButtonText: 'Igen',
        type: 'warning',
      })
        .then(() => {
          this.$router.replace('/representative-processes/payments');
        })
        .catch(() => {
        });
    },
    async store() {
      this.$refs['representativePaymentForm'].validate(async valid => {
        if (valid) {
          this.buttonLoading = true;
          try {
            if (this.type === 'add') {
              await this.$store.dispatch('representativePayment/create', this.representativePayment);
            } else {
              await this.$store.dispatch('representativePayment/update', this.representativePayment);
            }
            this.$store.dispatch('representativePayment/fetchAll');
            this.$router.replace('/representative-processes/payments');
          } catch (e) {
          }
          this.buttonLoading = false;
        }
      });
    },
  }
};
</script>
